import { Vue, RightHelper, AxiosResponse } from "./CoreBase";
import Axios from "axios";

export default abstract class BaseTLComponent extends Vue {

	protected alertModalTitle: string = '';
	protected alertModalContent: string = '';
	protected alertModalId: string = 'alertModalId';
	protected canDelete: boolean = false;
	protected canCreate: boolean = false;
	protected canUpdate: boolean = false;
	protected canRead: boolean = false;
	protected hasRight: boolean = false;
	protected isSuperUser: boolean = false;
	protected isOwnerPage: boolean = false;
	protected isBusy: boolean = false;
	protected timerSecondRefresh: number = 2000;
	protected timerHandle: number = 0;


	protected setTimer(seconds: number): void {
		this.timerSecondRefresh = seconds * 1000;
    }

	//TODO tohle pryc
	protected get objectIdFromParam(): number {
		return Number(this.$router.currentRoute.params.id);
	}

	protected get objectIdFromQuery(): number {
		return Number(this.$router.currentRoute.query.id);
	}

	protected initializeRights(createRightString: string | undefined, deleteRightString: string | undefined, readRightString: string | undefined, updateRightString: string | undefined) {
		this.canCreate = createRightString !== undefined && RightHelper.currentUserHasRight(createRightString);
		this.canDelete = deleteRightString !== undefined && RightHelper.currentUserHasRight(deleteRightString);
		this.canRead = readRightString !== undefined && RightHelper.currentUserHasRight(readRightString);
		this.canUpdate = updateRightString !== undefined && RightHelper.currentUserHasRight(updateRightString);

		this.hasRight = this.canDelete || this.canCreate || this.canUpdate || this.canRead;

		this.isSuperUser = RightHelper.currentUserIsSuperUser();
	}

	protected setOwner(): void {
		this.isOwnerPage = this.isOwner();
	}

	protected hasRightOrIsOwnerPage(): boolean {
		return (this.isOwnerPage || this.hasRight);
	}

	//VaPTODO - predelat seznamy, at dedi z BaseTLTableComponent a ne z BaseTLComponent
	//        - nasledne nastavit tuto metodu jako abstract
	protected isOwner(): boolean {
		return false;
	}


	protected showAlertModalWithInfoMessage(message: string) {
		this.showAlertModalWithTitleAndContent(this.$t('baseComponent.info').toString(), message);
	}

	protected showAlertModalWithErrorMessage(errorMessage: string) {
		this.showAlertModalWithTitleAndContent(this.$t('baseComponent.error').toString(), errorMessage);
	}

	protected showAlertModalWithErrorMessageList(errors: any) {
		this.showAlertModalWithErrorMessage(String(errors));
		//this.showAlertModalWithErrorMessage(JSON.stringify(errors));
	}

	protected showModal(modalId: string) {
		this.$bvModal.show(modalId);
	};

	protected setAlertModalId(alertModalId: string) {
		this.alertModalId = alertModalId;
	}

	protected showAlertModalWithTitleAndContent(title: string, content: string) {
		this.alertModalTitle = title;
		this.alertModalContent = content;
		this.showModal(this.alertModalId);
	};

	//defaultní hláška je : 'Nepodařilo se načíst data'
	protected showLoadDataErrorMessage(error: any, errorMessage: string = this.$t('baseComponent.errorLoadData').toString()) {

		if (error && error.response && error.response.data && error.response.data.errors) {
			errorMessage = error.response.data.errors;
		}
		this.showErrorMessage(this.$t('baseComponent.errorLoad').toString(), JSON.stringify(errorMessage));
	}

	protected showErrorMessage(errorMessage: string, errorTitle: string = this.$t('baseComponent.error').toString()) {
		this.showAlertModalWithTitleAndContent(errorTitle, errorMessage);
	}

	protected showAlertModalById( idModal: string) {	
		this.showModal(idModal);
	};

	protected isTokenExpired(response: any): boolean {
		if (response.type) {
			return response.type == 'IsTokenExpired';
		}
		return false;
	}

	protected NoCall(): Promise<AxiosResponse<any>> {
		//VaP - aby nebylo potreba impolemenatovat vsechny metody a pritom navratovka byla Promise<AxiosResponse<any>>
		return Axios.get('/');
	}
}